import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CroppedImage } from './CroppedImage';
import { BONUS_MOCKUP, BRAND, bonus } from '../data/resinContent';
export function BonusesSection() {
  return <section className="w-full bg-charcoal-900 py-12 sm:py-16" aria-labelledby="bonuses-title" data-id="element-22" data-mp="vt6402tjfgpm">
      <div className="mx-auto max-w-5xl px-5" data-id="element-23" data-mp="qt9w3shpz54s">
        <p className="text-center text-[10px] font-semibold uppercase tracking-[0.32em] text-champagne" data-id="element-24" data-mp="qsi2uoblhjho">
          Always included
        </p>
        <h2 id="bonuses-title" className="mt-3 text-center font-display text-[1.6rem] font-semibold uppercase leading-tight text-ivory-50 sm:text-[2.25rem]" data-id="element-25" data-mp="zv1453zqfo1t">
          + 1 Practical bonus
        </h2>

        <div className="mt-9 grid items-start gap-8 md:grid-cols-[0.9fr_1.1fr] md:gap-12" data-id="element-26" data-mp="19llzmik40cgi">
          <CroppedImage image={BONUS_MOCKUP} className="mx-auto w-full max-w-[18rem] md:max-w-none" data-id="element-27" data-mp="1nl3sb90j09v5" />

          <div data-id="element-28" data-mp="1jjrzyvq9paj9">
            <h3 className="font-display text-[1.7rem] font-semibold uppercase leading-tight text-ivory-50 sm:text-[2rem]" data-id="element-29" data-mp="1jk1oeevnz9mu">
              {bonus.title}
            </h3>
            <p className="mt-1.5 text-[13px] leading-snug text-ivory-300" data-id="element-30" data-mp="3tr5go3y1w9th">{bonus.subtitle}</p>

            <div className="mt-6 border-t border-charcoal-600 pt-6" data-id="element-31" data-mp="2lcnk1p2fbpw">
              <p className="text-[14px] text-body" data-id="element-32" data-mp="7kpbyqvl4qul">{bonus.hookLead}</p>
              <p className="mt-3 inline-block rounded-2xl rounded-bl-sm bg-charcoal-700 px-4 py-2.5 text-[15px] text-ivory-50" data-id="element-33" data-mp="7m0ekndansk4">
                “{bonus.hookMessage}”
              </p>
              <p className="mt-3 text-[14px] leading-relaxed text-ivory-100" data-id="element-34" data-mp="gju7rpfri632">{bonus.hookTail}</p>
            </div>

            <p className="mt-6 text-[12px] font-semibold uppercase tracking-[0.14em] text-ivory-300" data-id="element-35" data-mp="lcvnu0rpgbo8">
              {bonus.listIntro}
            </p>
            <ul className="mt-3 grid gap-x-4 gap-y-2 sm:grid-cols-2" data-id="element-36" data-mp="vataijtx20eq">
              {bonus.items.map(item => <li key={item} className="flex items-start gap-2" data-id="element-37" data-mp="10afowwlhdmp4">
                  <CheckIcon className="mt-1 h-3 w-3 shrink-0 text-champagne" strokeWidth={3} aria-hidden="true" data-id="element-38" data-mp="akz6e1hq12la" />
                  <span className="text-[14px] leading-snug text-ivory-200" data-id="element-39" data-mp="5mxd6nqkzmw3">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-10 text-center" data-id="element-40" data-mp="fkbu0ogf2dox">
          <p className="font-display text-[2.4rem] font-semibold uppercase leading-[1.05] text-champagne-light sm:text-[3.2rem]" data-id="element-41" data-mp="fjafub43tb2z">
            {bonus.micro.map(word => <span key={word} className="block sm:inline sm:px-2" data-id="element-42" data-mp="od5auqbihl4w">
                {word}
              </span>)}
          </p>
          <p className="mx-auto mt-3 max-w-md text-[14px] leading-relaxed text-body" data-id="element-43" data-mp="139e9bpnkvug9">{bonus.support}</p>
        </div>

        <p className="mt-9 border-y border-champagne/25 py-5 text-center text-[13px] font-semibold uppercase tracking-[0.16em] text-ivory-100" data-id="element-44" data-mp="y8qjv8ezzlo5">
          <span className="text-muted line-through" data-id="element-45" data-mp="302prnjswvkw3">Value: {bonus.value}</span>
          <span className="mt-1 block text-champagne sm:ml-3 sm:mt-0 sm:inline" data-id="element-46" data-mp="1fk5hq1ejrjnn">Free with {BRAND}</span>
        </p>
      </div>
    </section>;
}